import React from "react";
import * as IoIcons from "react-icons/io";
import CerrarSesion from "./CerrarSesion";

export const getSidebarDataUsuario = (correo) => [
  {
    title: correo || "Usuario",
    type: "profile",
    icon: <IoIcons.IoIosPerson />,
  },
  {
    title: "Reportes",
    path: `/InfoReportes/${correo}`,
    icon: <IoIcons.IoIosMap />,
  },
  {
    title: "",
    type: "logout",
    icon: <CerrarSesion />,
  },
];
